// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1Yie5","secondaryButton":"_19U7D","primaryButton":"_1uVeE"};